import React, { ReactChild } from 'react';
import { Button, createStyles, Dialog, Grid, Icon, IconButton, makeStyles, Theme } from '@material-ui/core';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';

import { ClassificationStatus } from '../../enum/ClassificationStatus';
import { InfluencerContext } from '../../NewsContext';

interface IReviewDialog {
    handleDeleteButton: () => void,
    handleDiscardButton: () => void,
    handleConfirmButton: () => void,
    open: boolean,
    children?: ReactChild
}

const useStyles = makeStyles((theme: Theme) => createStyles({    
    root: {
        maxWidth: '1076px',
        minWidth: '1076px',
        padding: '0.5rem'
    },
    deleteButton: {
        color: theme.palette.error.main,
        borderColor: theme.palette.error.main
    },
    content: {
        overflowY: 'hidden',
        paddingBottom: '1rem'
    },
    dialogActionPadding: {
        padding: '0.5rem 1.5rem 1rem 1.5rem' 
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(2),
        top: theme.spacing(2),
        color: theme.palette.grey[500],
    },
}));

export function ReviewDialog({
    handleDeleteButton, 
    handleConfirmButton, 
    handleDiscardButton, 
    open, 
    children}: IReviewDialog) {

    const classes = useStyles();
    
    const newsContext = React.useContext(InfluencerContext);

    return (
        <Dialog 
            maxWidth='lg'
            aria-labelledby="simple-dialog-title" 
            open={open}>
            <div className={classes.root}>
                <DialogContent className={classes.content}>
                    <IconButton aria-label="close" className={classes.closeButton} onClick={handleDiscardButton}>
                        <Icon>close</Icon>
                    </IconButton>
                    {children}
                </DialogContent>
                { newsContext.classification.status != ClassificationStatus.REMOVED && (
                    <DialogActions className={classes.dialogActionPadding}>
                        <Grid 
                            container
                            spacing={2}
                            direction="row"
                            justify="space-between"
                        >
                            <Grid item>
                                <Button 
                                    onClick={handleDeleteButton} 
                                    variant="outlined"
                                    size="large"
                                    className={classes.deleteButton}>
                                Remover
                                </Button>
                            </Grid>
                            <Grid item>
                                <Grid container spacing={2}>
                                    <Grid item>
                                        <Button 
                                            onClick={handleDiscardButton} 
                                            variant="outlined" 
                                            color="primary"
                                            size="large"
                                            disableElevation
                                        >
                                        Descartar
                                        </Button>
                                    </Grid>
                                    <Grid item>
                                        <Button 
                                            onClick={handleConfirmButton} 
                                            variant="contained" 
                                            color="primary"
                                            size="large"
                                            disableElevation
                                        >
                                        Salvar Alterações
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </DialogActions>
                )}
            </div>
        </Dialog>
    );
}